import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-5 bg-indigo-100" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Completed Purchases with dedications", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "Completed Purchases -- no dedication", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", null, "Started Paypay, did not complete", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_box, { class: "mb-6" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.completedWithDedicationOnly, (entry) => {
            return (_openBlock(), _createBlock("li", {
              key: entry.orderId
            }, [
              _createVNode(_component_box, { class: "p-2 m-5" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(entry.orderId) + " " + _toDisplayString(entry.contactInfo.name) + " " + _toDisplayString(entry.contactInfo.email) + " ", 1),
                  _createVNode("ol", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(entry.booksOrdered, (book, index) => {
                      return (_openBlock(), _createBlock("li", { key: index }, [
                        _createVNode("div", null, "Book " + _toDisplayString(index + 1) + " " + _toDisplayString(book.bookId), 1),
                        _createVNode("div", null, "Dedication: " + _toDisplayString(book.dedication), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_box, { class: "mb-6" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.completedNoDedication, (entry) => {
            return (_openBlock(), _createBlock("li", {
              key: entry.orderId
            }, [
              _createVNode(_component_box, { class: "p-2 m-5" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(entry.orderId) + " " + _toDisplayString(entry.contactInfo.name) + " " + _toDisplayString(entry.contactInfo.email) + " ", 1),
                  _createVNode("ol", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(entry.booksOrdered, (book, index) => {
                      return (_openBlock(), _createBlock("li", { key: index }, [
                        _createVNode("div", null, "Book " + _toDisplayString(index + 1) + " " + _toDisplayString(book.bookId), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_box, { class: "p-2 mb-6" }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.abandoned, (entry) => {
            return (_openBlock(), _createBlock("li", {
              key: entry.orderId
            }, _toDisplayString(entry.orderId) + " " + _toDisplayString(entry.contactInfo.name) + " " + _toDisplayString(entry.contactInfo.email), 1))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}